import moment from "moment-timezone"
import { BOOTCAMP_MODULE_TYPES } from "./bootcamp.constants"

export const calculateDays = date => {
  const accessible = date
  if (!accessible) {
    return {
      days: 0,
      text: "",
    }
  }
  const accessibleDate = moment.utc(
    moment.tz(accessible.date, accessible.timezone)
  )
  const today = moment.utc()
  const days = Math.ceil(moment.duration(accessibleDate.diff(today)).asDays())

  return { days, text: accessibleDate.fromNow() }
}

export const isModuleCompleted = (module, progress) => {
  if (!progress) return false
  return isQuestion(module)
    ? progress[module.segment.id].completion_status === "completed"
    : progress[module.id].completion_status === "completed"
}

export const isQuestion = module => {
  try {
    return module.moduleType === BOOTCAMP_MODULE_TYPES.QUESTION
  } catch (error) {
    return false
  }
}

export const isModuleActive = (currentModule, module) => {
  if (!currentModule) return false
  return (
    currentModule.id === module.id ||
    (currentModule.segment && currentModule.segment.id === module.id)
  )
}

export const constructModuleQueue = chapters => {
  const queue = []
  chapters.forEach(chapter => {
    chapter.segments.forEach(segment => {
      const accessibleDays = calculateDays(segment.accessible_at)
      segment.accessibleDays = accessibleDays
      segment.moduleType = BOOTCAMP_MODULE_TYPES.ENTRY
      segment.chapterId = chapter.id
      queue.push(segment)
      if (segment.questions && segment.questions.length) {
        segment.questions.forEach(question => {
          question.moduleType = BOOTCAMP_MODULE_TYPES.QUESTION
          question.chapterId = chapter.id
          queue.push(question)
          question.segment = segment
          question.accessibleDays = accessibleDays
        })
      }
    })
  })
  return queue
}

export const getModuleById = (id, modules) => {
  return modules.find(module => module.id === id)
}

export const getTaskBySegmentId = (id, tasks) => {
  return tasks.find(task => task.ref.data.segment_id === id)
}



// WEBPACK FOOTER //
// ./src/store/bootcamp/bootcamp.utils.js